export const buttonAuth = {
  student: [5, 7],
  teacher: [5, 7, 9],
}
export const staticData = {
  helpDocUrl: 'https://www.yuque.com/docs/share/d69dc2d5-029f-48dc-a647-6475d39410a2?#',
  feedbackMail: 'intschoolsupport@huaercollegiate.com',
}

export default {
  buttonAuth,
  staticData,
}
